<template>
    <section class="pt-5 pb-5" style="min-height:600px;">
        <div class="container" id="reserva-card">
            <div class="row justify-content-center d-flex-vertical-center">

                <!-- <div class="col-12 col-md-6 offset-md-3">
                    <p class="s-32 s-32-sm fw-500 mb-1 pl-1">
                        <span class="text-white">Somos Comfy</span>
                    </p>
                    <p class="s-24 s-30-sm font-weight-normal mb-4 pl-1 text-center">
                        <span class="text-white">Reserva tu masaje</span>
                    </p>
                </div> -->

                <!-- Pasos -->
                <div class="col-12 col-md-6">
                    <div class="card card-reserva">

                        <Progreso :step="servicio.step" @reloadPage="reloadPage"></Progreso>

                        <div class="card-header text-center s-18 white-text comfy font-weight-bold font-italic">
                            <span class="ivy-bold">Reserva {{ cliente.nombre ? ' de ' + cliente.nombre : '' }}</span>
                        </div>

                        <div class="card-block p-2">
                            <PasoUno v-show="servicio.step == 0" :url="url" :servicio="servicio" :cliente="cliente"></PasoUno>
                            <PasoDos v-show="servicio.step == 1" :url="url" :servicio="servicio"></PasoDos>
                            <PasoTres v-if="servicio.step == 2" :url="url" :servicio="servicio" :cliente="cliente"></PasoTres>
                            <Final v-if="servicio.step == 3" :url="url" :servicio="servicio" :cliente="cliente"></Final>
                        </div>

                        <Steps :servicio="servicio" :cliente="cliente" @nextStep="nextStep" @prevStep="prevStep"></Steps>

                    </div>

                    <!-- <p class="s-18 comfy-text my-5 d-none d-md-block">
                        <img class="w-100 mb-4" :src="url + '/frontend/img/promos/v2/text.png'">
                    </p> -->

                </div>

                <!-- banner dinámico -->
                <!-- <div class="col-md-6 d-block d-md-none">
                    <img class="img-promo w-100 mt-4" :src="url + '/frontend/img/promos/v2/text-responsive.png'">
                </div> -->
                <!-- fin banner dinámico -->

                <!-- <div class="col-md-6 d-none d-md-block">
                    <img class="w-100" :src="url + '/frontend/img/promos/v2/info.png'">
                </div> -->

                <!-- banner animado
                <div class="col-lg-6 col-md-down">
                    <div class="container">
                        <div class="table">
                            <div class="header-text">
                                <h1 class="s-32 comfy-second-text font-weight-bold">Masajes y Fisioterapia a Domicilio</h1>
                                <h2 class="cd-headline zoom text-white">
                                    <span class="cd-words-wrapper waiting">
                                        <b class="is-visible">MASAJE RELAJANTE</b>
                                        <b class="">MASAJE DEPORTIVO</b>
                                        <b class="">MASAJE POSTPARTO</b>
                                        <b class="">MASAJE ALGO</b>
                                    </span>
                                </h2>
                                <div class="pt-5 text-white">
                                    <p>Tenemos disponibilidad en Bogotá, Chía, Cájica y La Calera</p>
                                    <p>Horario: Lunes a Domingo entre 7am y 10pm.</p>
                                    <p>Las profesionales llevan todos los implementos necesarios para el servicio.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                -->

            </div>
        </div>

    </section>
</template>

<style>
.card.card-reserva {
    box-shadow: 0px 0px 25px 1px rgb(12 59 90 / 30%);
}
</style>

<script>
    // Pasos
    import PasoUno from './pasouno/PasoUno'
    import PasoDos from './pasodos/PasoDos'
    import PasoTres from './pasotres/PasoTres'
    import Final from './pasocuatro/Final'
    import Progreso from './Progreso'

    // Steps
    import Steps from '../steps/Steps'

    export default {
        components: {Steps, PasoUno, PasoDos, PasoTres, Final, Progreso},
        props: [
            'url', 'cliente'
        ],
        data() {
            return {
                servicio: {
                    anticipadoPorcentaje: '',
                    anticipadoHoras: '',
                    anticipadoValor: '',
                    busqueda: '',
                    ciudad: '',
                    cobertura: false,
                    codigo: {
                        codigoInput: '',
                        tipo: '',
                        tipoUso: '',
                        descuento: '',
                        valido: false,
                    },
                    tarifaDinamica: 0,
                    tarifaDinamicaUno: 0,
                    tarifaDinamicaDos: 0,
                    tarifaDinamicaTres: 0,
                    tarifaDinamicaCuatro: 0,
                    tarifaDinamicaCinco: 0,
                    desplazamiento: 0,
                    desplazamientoUno: 0,
                    desplazamientoDos: 0,
                    desplazamientoTres: 0,
                    desplazamientoCuatro: 0,
                    desplazamientoCinco: 0,
                    datosDireccion: {
                        direccion: null,
                        ascensor: null,
                        parqueadero: null,
                        valorAscensor: null,
                        valorParqueadero: null,
                    },
                    duracion: '',
                    fecha: '',
                    genero: 'aleatorio',
                    hora: '',
                    horas: '',
                    masajeValor: 0,
                    masajeUnoValor: 0,
                    masajeDosValor: 0,
                    masajeTresValor: 0,
                    masajeCuatroValor: 0,
                    masajeCincoValor: 0,
                    masaje_uno: '',
                    masaje_dos: '',
                    masaje_tres: '',
                    masaje_cuatro: '',
                    masaje_cinco: '',
                    next: false,
                    precio: '',
                    precioFinal: '',
                    precioAscensor: '',
                    precioParqueadero: '',
                    prev: false,
                    step: 0,
                    terapistaUno: '',
                    terapistaDos: '',
                    terapistaTres: '',
                    terapistaCuatro: '',
                    terapistaCinco: '',
                    tipo: '',
                    valorCobertura: '0',
                    grupal: '2',
                    inicioConstruccion: this.getCurrentTime(),
                }
            }
        },
        watch: {
            'servicio.busqueda': function(val){
                this.servicio.next = false
                if(this.servicio.busqueda && this.servicio.tipo && this.servicio.step == 0){
                    this.servicio.next = true
                }
            },
            'servicio.hora': function(){
                this.servicio.precio = ''
            },

            // Calcular tarifa dinámica
            'servicio.tarifaDinamicaUno': function(){
                this.servicio.tarifaDinamica = parseInt(this.servicio.tarifaDinamicaUno + this.servicio.tarifaDinamicaDos + this.servicio.tarifaDinamicaTres + this.servicio.tarifaDinamicaCuatro + this.servicio.tarifaDinamicaCinco)
                this.calcularPrecio()
            },
            'servicio.tarifaDinamicaDos': function(){
                this.servicio.tarifaDinamica = parseInt(this.servicio.tarifaDinamicaUno + this.servicio.tarifaDinamicaDos + this.servicio.tarifaDinamicaTres + this.servicio.tarifaDinamicaCuatro + this.servicio.tarifaDinamicaCinco)
                this.calcularPrecio()
            },
            'servicio.tarifaDinamicaTres': function(){
                this.servicio.tarifaDinamica = parseInt(this.servicio.tarifaDinamicaUno + this.servicio.tarifaDinamicaDos + this.servicio.tarifaDinamicaTres + this.servicio.tarifaDinamicaCuatro + this.servicio.tarifaDinamicaCinco)
                this.calcularPrecio()
            },
            'servicio.tarifaDinamicaCuatro': function(){
                this.servicio.tarifaDinamica = parseInt(this.servicio.tarifaDinamicaUno + this.servicio.tarifaDinamicaDos + this.servicio.tarifaDinamicaTres + this.servicio.tarifaDinamicaCuatro + this.servicio.tarifaDinamicaCinco)
                this.calcularPrecio()
            },
            'servicio.tarifaDinamicaCinco': function(){
                this.servicio.tarifaDinamica = parseInt(this.servicio.tarifaDinamicaUno + this.servicio.tarifaDinamicaDos + this.servicio.tarifaDinamicaTres + this.servicio.tarifaDinamicaCuatro + this.servicio.tarifaDinamicaCinco)
                this.calcularPrecio()
            },

            // Calcular valor masajes
            'servicio.masajeUnoValor': function(){
                this.servicio.masajeValor = parseInt(this.servicio.masajeUnoValor + this.servicio.masajeDosValor + this.servicio.masajeTresValor + this.servicio.masajeCuatroValor + this.servicio.masajeCincoValor)
                this.calcularPrecio()
            },
            'servicio.masajeDosValor': function(){
                this.servicio.masajeValor = parseInt(this.servicio.masajeUnoValor + this.servicio.masajeDosValor + this.servicio.masajeTresValor + this.servicio.masajeCuatroValor + this.servicio.masajeCincoValor)
                this.calcularPrecio()
            },
            'servicio.masajeTresValor': function(){
                this.servicio.masajeValor = parseInt(this.servicio.masajeUnoValor + this.servicio.masajeDosValor + this.servicio.masajeTresValor + this.servicio.masajeCuatroValor + this.servicio.masajeCincoValor)
                this.calcularPrecio()
            },
            'servicio.masajeCuatroValor': function(){
                this.servicio.masajeValor = parseInt(this.servicio.masajeUnoValor + this.servicio.masajeDosValor + this.servicio.masajeTresValor + this.servicio.masajeCuatroValor + this.servicio.masajeCincoValor)
                this.calcularPrecio()
            },
            'servicio.masajeCincoValor': function(){
                this.servicio.masajeValor = parseInt(this.servicio.masajeUnoValor + this.servicio.masajeDosValor + this.servicio.masajeTresValor + this.servicio.masajeCuatroValor + this.servicio.masajeCincoValor)
                this.calcularPrecio()
            },

            // Calcular valor desplazamiento
            'servicio.desplazamientoUno': function(){
                this.servicio.desplazamiento = parseInt(this.servicio.desplazamientoUno + this.servicio.desplazamientoDos + this.servicio.desplazamientoTres + this.servicio.desplazamientoCuatro + this.servicio.desplazamientoCinco)
                this.calcularPrecio()
            },
            'servicio.desplazamientoDos': function(){
                this.servicio.desplazamiento = parseInt(this.servicio.desplazamientoUno + this.servicio.desplazamientoDos + this.servicio.desplazamientoTres + this.servicio.desplazamientoCuatro + this.servicio.desplazamientoCinco)
                this.calcularPrecio()
            },
            'servicio.desplazamientoTres': function(){
                this.servicio.desplazamiento = parseInt(this.servicio.desplazamientoUno + this.servicio.desplazamientoDos + this.servicio.desplazamientoTres + this.servicio.desplazamientoCuatro + this.servicio.desplazamientoCinco)
                this.calcularPrecio()
            },
            'servicio.desplazamientoCuatro': function(){
                this.servicio.desplazamiento = parseInt(this.servicio.desplazamientoUno + this.servicio.desplazamientoDos + this.servicio.desplazamientoTres + this.servicio.desplazamientoCuatro + this.servicio.desplazamientoCinco)
                this.calcularPrecio()
            },
            'servicio.desplazamientoCinco': function(){
                this.servicio.desplazamiento = parseInt(this.servicio.desplazamientoUno + this.servicio.desplazamientoDos + this.servicio.desplazamientoTres + this.servicio.desplazamientoCuatro + this.servicio.desplazamientoCinco)
                this.calcularPrecio()
            }
        },
        methods: {
            nextStep(val){
                // console.log('--- avanzando al siguiente paso ---')
                this.servicio.step = val
                this.servicio.next = false
                this.servicio.prev = true
            },
            prevStep(val){
                this.servicio.step = this.servicio.step - 1
                if(this.servicio.step == 0){
                    this.servicio.prev = false
                    this.servicio.next = true
                }
            },
            reloadPage(val){
                if(val == 1){
                    window.location.href = this.url + '/reservar'
                }
            },
            calcularPrecio(){
                this.servicio.precio = parseInt(this.servicio.masajeValor + this.servicio.desplazamiento + this.servicio.tarifaDinamica)
                // console.log(this.servicio.precio)
                // console.log(this.servicio.precio)
                // console.log(this.servicio.tarifaDinamica)
                // this.servicio.precioFinal = parseInt(this.servicio.precio + this.servicio.tarifaDinamica)
                // console.log(this.servicio.precioFinal)
            },
            getCurrentTime(){
                var today = new Date()
                const date = today.getFullYear()+'-'+('0' + (today.getMonth()+1)).slice(-2)+'-'+today.getDate()
                const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds()
                const dateTime = date +' '+ time
                return dateTime
            }
        },
        mounted() {
            // console.log('--- service component mounted ---')
            // this.getAnticipado();
            EventBus.$on('limpiarPasoDos', data => {
                // console.log('--- limpiando paso dos ---')
                this.anticipadoPorcentaje = 0
                this.anticipadoHoras = 0
                this.anticipadoValor = 0
                this.servicio.busqueda = ''
                this.servicio.tarifaDinamica = 0
                this.servicio.tarifaDinamicaUno = 0
                this.servicio.tarifaDinamicaDos = 0
                this.servicio.tarifaDinamicaTres = 0
                this.servicio.tarifaDinamicaCuatro = 0
                this.servicio.tarifaDinamicaCinco = 0
                this.servicio.desplazamiento = 0
                this.servicio.desplazamientoUno = 0
                this.servicio.desplazamientoDos = 0
                this.servicio.desplazamientoTres = 0
                this.servicio.desplazamientoCuatro = 0
                this.servicio.desplazamientoCinco = 0
                this.servicio.duracion = ''
                this.servicio.fecha = ''
                this.servicio.grupal = '2'
                this.servicio.hora = ''
                this.servicio.horas = ''
                this.servicio.masajeValor = 0
                this.servicio.masaje_uno = ''
                this.servicio.masajeUnoValor = 0
                this.servicio.masaje_dos = ''
                this.servicio.masajeDosValor = 0
                this.servicio.masaje_tres = ''
                this.servicio.masajeTresValor = 0
                this.servicio.masaje_cuatro = ''
                this.servicio.masajeCuatroValor = 0
                this.servicio.masaje_cinco = ''
                this.servicio.masajeCincoValor = 0
                this.servicio.precio = ''
                this.servicio.precioNeto = ''
                this.servicio.precioFinal = ''
                this.servicio.terapistaUno = ''
                this.servicio.terapistaDos = ''
                this.servicio.terapistaTres = ''
                this.servicio.terapistaCuatro = ''
                this.servicio.terapistaCinco = ''
            });
            EventBus.$on('authUser', data => {
                this.servicio.ciudad = ''
                this.servicio.datosDireccion.direccion = ''
            });
            if(this.cliente && this.cliente.opt_verified == false){
                console.log('user not verified');
            } else {
                console.log('user verified');
            }
        }
    }
</script>
